// @import dependencies
import React, { CSSProperties, useState, useEffect } from 'react'
import moment from 'moment'
// @end dependencies

// @import components
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import Slider from 'react-slick';
import IconComponent from 'app_components/commons/icons';
import OffercardCommon from 'app_components/commons/offercard';
// @end components

// @import types
import { ICourse } from 'app_types/campus/academic/courseTypes';
// @end types

// @import services
import CourseService from 'app_services/campus/academic/courseService';
import {routingService} from 'app_services/routingService'
// @end services

// @import hooks
import { useColors } from 'app_hooks/useColors';
import useWindowWidth from 'app_hooks/useWindowWidth';
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './CourseSliderModule.scss'
import { Link } from 'react-router-dom';
// @end styles

interface ICourseSliderModuleProps {
  className?: string
  style?: CSSProperties
  id?: string
  title?: string
  description?: string
  filter?: 'discount' | 'new'
  hidePrice?: boolean
  size?: number
}

const CourseSliderModule: React.FC<ICourseSliderModuleProps> = (props) => {

  const [colors] = useColors();
  const { windowWidth } = useWindowWidth();
  const [coursesList, updateCoursesList] = useState<ICourse[]>([]);
  const size = props?.size || 10

  // @INFO Servicios
  const courseService = new CourseService();

  useEffect(() => {
    getCourses();
  }, [])

  const getNumberItems = () => {
    if(windowWidth < 576){
      return 1
    }
    if(windowWidth < 991){
      return 2
    }
    return 4
  }

  const getCourses = async () => {

    let httpParams: any = {
      pageNumber: 1,
      nPerPage: size,
      startPublicationDate: {
        date: 'today',
        direction: 'lte'
      },
      endPublicationDate: {
        date: 'today',
        direction: 'gte'
      },
      startDate: {
        date: 'today',
        direction: 'gte'
      },
      sort: {
        field: 'startDate',
        direction: '1'
      },
      publish: true,
    }

    if (props.filter === 'discount') {
      httpParams['price'] = 'discount'
    }

    if (props.filter === 'new') {
      httpParams['new'] = true
    }

    const coursesResponse = await courseService.fetchCourses(httpParams);

    let courses: Array<any> = []

    if (coursesResponse && coursesResponse.courses) {
      courses = coursesResponse.courses.reduce((accum: any, element: any) => {
        let startDate = moment.utc(element?.startDate).format('DD/MM/YY')
        let item = {
          key: element?._id,
          elementType: 'course',
          ...element,
          startDate,
        }

        accum.push(item)

        return accum
      }, [])
    }

    updateCoursesList(courses);

  }

  return(
    <div
      className={`course_slider_module-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      {coursesList.length ?
        <div
          style={{
            textAlign: 'center'
          }}
        >
          {props.title ?
            <TextComponent
              type='title'
            >
              {props.title}
            </TextComponent>
          :null}
          {props.description ?
            <TextComponent
              type='text'
            >
              {props.description}
            </TextComponent>
          :null}
        </div>
      :null}
      {coursesList.length ?
        <Slider
          arrows={true}
          className='slider-page'
          infinite={(coursesList.length >= getNumberItems()) ? true : false}
          slidesToShow={getNumberItems()}
          nextArrow={<CustomArrow icon={<IconComponent svg='ArrowCircleRight' width={24} color={colors.primary} />}/>}
          prevArrow={<CustomArrow icon={<IconComponent svg='ArrowCircleLeft' width={24} color={colors.primary} />}/>}
        >
          {coursesList.map((_item) => (
            <div
              key={_item._id}
              className='container-offer-card-page'
            >
              <OffercardCommon
                // @ts-ignore
                course={_item}
                link={routingService.getPublicPath(`/curso/${_item._id}`)}
                hideValidUntil
                hidePrice={props.hidePrice}
              />
            </div>
          ))}
        </Slider>
      :null}
      {coursesList.length ?
        <Link
          to="/cursos"
        >
          <TextComponent
            type='text'
            style={{
              textDecoration: 'underline',
              cursor: 'pointer'
            }}
          >
            Ver mas
          </TextComponent>
        </Link>
      :null}
    </div>
  );
}

// ======================================
// Flecha
// ======================================
const CustomArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      {props.icon}
    </div>
  );
}

export default CourseSliderModule;
